module.exports = __webpack_public_path__ + "img/Boutique.c7d24f34.png";